module.exports = __webpack_public_path__ + "img/home-line4-img3.f48c00a7.png";